import * as React from 'react';

import {IframeComponent} from 'shells/iframe/iframe-component';
import {Illustration} from 'shells/illustrations/illustration';

import type {PreviewType} from './consts';
import {Footer} from './footer';

type Props = {
    previewWebsiteUrl: string;
    embedScript: string;
    previewType: PreviewType;
    instanceId: string | number;
    canEmbedInIframe?: boolean | null | undefined;
    isDevelopment?: boolean;
};

export function ChatPreviewRoot(props: Props) {
    return (
        <>
            {props.canEmbedInIframe ? (
                <IframeComponent
                    src={`${props.previewWebsiteUrl}?ns_is_embedded_preview=1`}
                    title='Chat Preview'
                />
            ) : (
                <Illustration src='chat-preview-fallback' width='100%' />
            )}
            <Footer
                embedScript={props.embedScript}
                previewType={props.previewType}
                instanceId={props.instanceId}
                isDevelopment={props.isDevelopment}
            />
        </>
    );
}
